<template>
    <editing-sub-frame :sub_type="sub_type" :sub_code="sub_code">
        <!--제목, 컴포넌트 기본 공통 -->
        <template #head>
            <!--제목, 컴포넌트 기본 공통 -->
            
            <!--     label이 있는 경우에만 폼 활성화        -->
            <template v-if="label">
                <div class="mt-3 mb-1 fw-600 f-90"> Sub label *</div>
                <b-form-input v-model="sub_label" placeholder="필수 입력" />    
            </template>
            
            <div class="mt-3 mb-1 fw-600 f-90"> Sub type </div>
            <div class="d-flex justify-content-between">
                <b-dropdown :text="sub_type" variant="dark-border" class="mr-2">
                    <b-dropdown-item-button v-for="(sub_type, sub_type_idx) in sub_types"
                        :key="`subs-guidetext-subtype-opt-${sub_type}-${sub_type_idx}`"
                        @click="selectType(sub_type)"
                        >
                        {{ sub_type }}
                    </b-dropdown-item-button>
                </b-dropdown>

                <b-input v-model="sub_name" placeholder="Title"/>
            </div>

            <div class="mt-3 mb-1 fw-600 f-90">Description</div>
            <b-textarea v-model="sub_description" placeholder="A1. ㅇㅇㅇ을 관리하고 있습니까?"> {{ sub_description }} </b-textarea>
        </template>
        
        <template #structure>
            <!-- DF GuideText -->
            <div class="mt-3 mb-1 f-90 d-flex justify-content-between">
                <div class="fw-600 "> Structure</div>
                <div class="d-flex justify-content-end">
                    <b-form-checkbox v-model="sub_data_contents.is_toggle" class="mr-3 blue"
                                     @change="changeIsToggleBtn"
                    >토글 유무</b-form-checkbox>
                    <b-form-checkbox v-if="sub_data_contents.is_toggle" v-model="sub_data_contents.toggled" class="mr-3 blue">기본으로 닫기</b-form-checkbox>
                    <b-form-checkbox v-model="sub_data_contents.html" class="mr-3 blue">Html</b-form-checkbox>
                    <b-form-checkbox v-model="sub_data_contents.bordered" class="blue">테두리 박스 있음</b-form-checkbox> 
                </div>                      
            </div>
            <template v-if="sub_data_contents.is_toggle">
                <div class="f-80 fw-500">KO</div>
                <div class="d-flex my-2" style="gap: 8px">
                    <b-input v-model="sub_data_contents.toggle_title[0]" placeholder="국문 토글 버튼 Title"/>
                    <b-input v-model="sub_data_contents.toggle_title[1]" placeholder="영문 토글 버튼 Title"/>
                    <b-input v-model="sub_data_contents.toggle_title[2]" placeholder="중문 토글 버튼 Title"/>
                </div>
            </template>
           
            <div class="f-80 fw-500">KO</div>
            <b-textarea v-model="sub_data_contents.structure[0]" placeholder="국문 가이드텍스트를 입력해주세요" rows="5"></b-textarea>
            <div class="f-80 fw-500">EN</div>
            <b-textarea v-model="sub_data_contents.structure[1]" placeholder="영문 가이드텍스트를 입력해주세요" rows="5"></b-textarea>
            <div class="f-80 fw-500">CA</div>
            <b-textarea v-model="sub_data_contents.structure[2]" placeholder="중문 가이드텍스트를 입력해주세요" rows="5"></b-textarea>
            <div class="f-80 fw-500">Position</div>
            <div class="d-flex my-2" style="gap: 8px">
                <b-input v-model="sub_data_contents.margin_top" placeholder="top 여백 조정"/>
                <b-input v-model="sub_data_contents.margin_bottom" placeholder="bottom 여백 조정"/>
            </div>
        </template>

        <template #option>
            <b-list-group>
                <b-list-group-item>
                    <editing-sub-submit-required v-model="submit_required" :sub_code="sub_code" />
                </b-list-group-item>

                <b-list-group-item>
                    <b-form-group
                        label-cols="12"
                        label-cols-md="4"
                        label-cols-xl="2"
                        content-cols="12"
                        content-cols-md="8"
                        content-cols-xl="9"
                        label="Tags"
                        :label-for="`editing-subs-guidetext-${sub_code}-tags`"
                        class="align-items-center mb-0"
                        >
                        <b-input :id="`editing-subs-guidetext-${sub_code}-tags`" v-model="tags"
                            placeholder="띄어쓰기 대신 _ 사용, 쉼표로 구분"
                            />
                    </b-form-group>
                </b-list-group-item>
            </b-list-group>
        </template>

        <template #footer>
            <div class="text-right">
                <b-button variant="blue" class="mr-2"
                    @click="handleSaveSub"
                    :disabled="is_saving_subs"
                    >
                    <div class="d-flex align-items-center">
                        저장 <b-spinner v-show="is_saving_subs" small class="ml-2" />
                    </div>
                </b-button>
                <b-button @click="$emit('click-cancel')" variant="dark">취소</b-button>
            </div>
        </template>
    </editing-sub-frame>
</template>

<script>
import { EditingSubComponentMixin } from '@core_mixins/EditingSubComponentMixin'

export default {
    name: 'editing-df-guidetext',
    mixins: [EditingSubComponentMixin],
    methods: {
        async handleSaveSub () {
            if (await this.saveSub()) this.$emit('click-save')
        },
        changeIsToggleBtn(){
            if(this.sub_data_contents.is_toggle){
                this.$set(this.sub_data_contents, 'toggle_title', ['', '', ''])
            }
            else {
                this.$delete(this.sub_data_contents, 'toggle_title')
            }
        }
    },
}
</script>
